// Mapbox token from environment variable
const MAPBOX_TOKEN = import.meta.env.VITE_LOVABLE_CONNECTOR_MAPBOX_PUBLIC_TOKEN;

if (!MAPBOX_TOKEN) {
  console.warn('VITE_LOVABLE_CONNECTOR_MAPBOX_PUBLIC_TOKEN is not configured. Geocoding functionality will be limited.');
}

export const reverseGeocode = async (latitude: number, longitude: number): Promise<string> => {
  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${MAPBOX_TOKEN}&types=place,locality,neighborhood`
    );
    
    if (!response.ok) {
      throw new Error('Geocoding request failed');
    }
    
    const data = await response.json();
    
    if (data.features && data.features.length > 0) {
      const feature = data.features[0];
      
      // Try to get city and state/region
      const context = feature.context || [];
      const placeName = feature.text || feature.place_name;
      
      // Find region/state in context
      const region = context.find((item: any) => 
        item.id.includes('region') || item.id.includes('province')
      );
      
      if (region) {
        return `${placeName}, ${region.text}`;
      }
      
      return placeName;
    }
    
    return 'Location';
  } catch (error) {
    console.error('Error reverse geocoding:', error);
    return 'Location';
  }
};

// Cache for location names to avoid repeated API calls
const locationCache = new Map<string, string>();

export const getCachedLocation = async (latitude: number, longitude: number): Promise<string> => {
  const key = `${latitude.toFixed(4)},${longitude.toFixed(4)}`;
  
  if (locationCache.has(key)) {
    return locationCache.get(key)!;
  }
  
  const location = await reverseGeocode(latitude, longitude);
  locationCache.set(key, location);
  
  return location;
};
